import React, { useState,useEffect,useRef } from 'react';
// 아이콘 사용을 위해 react-icons/fa를 사용합니다.
import { FaPencilAlt, FaSearch, FaStar,FaTimes } from 'react-icons/fa';
import { getdailylook } from '../network/get_dailylook';
import {  MdOutlineIosShare, MdOutlineCameraAlt } from "react-icons/md";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { FaRegHeart,FaHeart } from "react-icons/fa";

import { useSearchParams, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import ImagePopup from '../components/ImagePopup';

import { postFollow } from '../network/post_follow';
import { postUnfollow } from '../network/post_unfollow';
import { getRecommuser } from '../network/get_recommuser';

import {MY_URL, toggleDailylookLikes } from '../client';
import { LoginRequiredModal } from '../components/loginpopup';
import { ProfileRequiredModal } from '../components/profilepopup';



// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 


// 탭 항목 정의
const TABS = [
  { key: 'rating', label: '평가' },
  { key: 'recommend', label: '추천' },
  { key: 'favorite', label: '찜' },
  { key: 'vote', label: '투표' },
];

     const TOAST_DURATION = 2000; // 2초


const TimeAgo = ({ isoString }) => {
  // 1. dayjs 객체 생성
  const time = dayjs(isoString);
  
  // 2. 현재 시간으로부터 상대적인 시간을 계산 (예: "1년 전", "2시간 전")
  const timeAgoText = time.fromNow();

  return (
    <span title={isoString} style={{ 
                marginLeft:'5pt',
                fontSize: '12px',
                color: '#000'
            }}>
      {timeAgoText}
    </span>
  );
};


  // 2. 이미지의 실제 크기를 저장할 상태

  const bannerSettings = {
    dots: true, // 하단에 점(dot) 페이지네이션 표시
    arrows: false, // 이전/다음 버튼 숨김
    infinite: true, // 무한 반복
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3000,

    
  };


function CircularImageSquare({ src, alt, size = 100 }) {
  const imageStyle = {
    width: size,       // 가로 크기
    height: size,      // 세로 크기를 가로 크기와 동일하게 설정 (정사각형)
    borderRadius: '50%', // ⭐️ 핵심: 50%로 설정하여 원형으로 만듦
    objectFit: 'cover', // 이미지가 컨테이너를 채우도록 하며, 필요시 잘림
    display: 'block',    // 인라인 요소의 불필요한 여백 제거
     marginRight: '10px'
  };

  return (
    <img src={src} alt={alt} style={imageStyle} />
  );
}

function ShareButton({ linkToCopy }) {
  // 1. 토스트 메시지 표시 상태 관리
  const [showToast, setShowToast] = useState(false);

  // 2. 복사 및 알림을 처리하는 단일 함수
  const handleCopy = async () => {
    if (!linkToCopy) {
      console.error("복사할 링크가 없습니다.");
      return;
    }

    try {
      // ⭐️ 클립보드 API를 사용하여 링크 복사
      await navigator.clipboard.writeText(linkToCopy);

      // ⭐️ 복사 성공 시 토스트 메시지 표시
      setShowToast(true);

      // ⭐️ 일정 시간 후 토스트 메시지 숨김
      setTimeout(() => {
        setShowToast(false);
      }, TOAST_DURATION);

    } catch (err) {
      console.error('클립보드 복사 실패:', err);
      alert('클립보드 복사에 실패했습니다. 브라우저 권한을 확인해주세요.');
    }
  };

  return (
    <div style={styles.container}>

              <MdOutlineIosShare size="24"  onClick={handleCopy} style={{
        marginLeft: '15px', // 아이콘 간의 간격
        cursor: 'pointer',
        marginRight:'5pt'
    }} />


      {/* ⭐️ 토스트 메시지 (조건부 렌더링) */}
      {showToast && (
        <div style={styles.toast}>
          링크를 복사했습니다. ✅
        </div>
      )}
    </div>
  );
}


const Fashion_tab = () => {
   const imageRef = useRef(null);
     const [activeTab, setActiveTab] = useState('rating');
  const [dailylook, setDailylook] = useState(null)
     const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

     const [showEquipments, setShowEquipments] = useState(true);
         const [isPopupOpen, setIsPopupOpen] = useState(false);
         const [isLoading, setIsLoading] = useState(true);

            const [userProfile, setUser] = useState(true);


            const [recommUsers, setRecommUsers] = useState([]);

            const [isrecommview, setIsrecommview] = useState(false);
            const [islike, setIslike] = useState(false);
              const [isFound, setIsFound] = useState(true);


                    const [showLoginModal, setShowLoginModal] = useState(false);
                          const [showProfileModal, setShowProfileModal] = useState(false);

     const stars = [1, 2, 3, 4, 5];


     const handleImgLoad = () => {
    setIsLoading(false);
  };

     const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

     const toggleEquipments = () => {
        setShowEquipments(prev => !prev); // 현재 상태를 반전시킵니다.
    };


     const follow = async () => {
       
       if(userProfile.is_followed){
        
        const _user = await postUnfollow(userProfile.id)
       setUser(_user)
       setIsrecommview(false)

       }else{
       const _user = await postFollow(userProfile.id)
       if(_user == 'PROFILE_NOT_FILLED'){
          setShowProfileModal(true)
       }else{
       setUser(_user)
       setIsrecommview(true)
       }
       }
    };


      const like = async () => {
       
       if(islike){
        
        toggleDailylookLikes(dailylook.id)
        setIslike(false)


       }else{
        toggleDailylookLikes(dailylook.id)
        setIslike(true)
       }
    };

    const toggleRecommUserFollow = async (userToToggle) => {
        const action = userToToggle.is_followed ? postUnfollow : postFollow;
        
        try {
            const updatedUser = await action(userToToggle.id);
            
            // recommsUsers 배열 업데이트: 해당 유저의 is_followed 상태를 토글
            setRecommUsers(prevUsers => 
                prevUsers.map(user => 
                    user.id === updatedUser.id ? updatedUser : user
                )
            );
        } catch (error) {
            console.error("팔로우/언팔로우 실패:", error);
        }
    };

           const navigate = useNavigate();




  // 3. 이미지 로드 완료 시 크기를 측정하여 상태에 저장하는 핸들러
  const handleImageLoad = () => {
    if (imageRef.current) {
      setImageSize({
        width: imageRef.current.offsetWidth,
        height: imageRef.current.offsetHeight,
      });
      console.log(`이미지 로드 완료. 크기: ${imageRef.current.offsetWidth}x${imageRef.current.offsetHeight}`);
    }
  };
  // 현재 활성화된 탭 상태 관리 (초기값: 'rating')
    const getLimitedPosition = (dy, dx, buttonWidth, buttonHeight) => {
    const { width: imgW, height: imgH } = imageSize;

    // 이미지 크기가 아직 로드되지 않았다면 원래 위치를 반환 (임시)
    if (imgW === 0 || imgH === 0) {
      return { top: dy, left: dx };
    }

    // Y축 (Top) 제한: 0 이상, (이미지 높이 - 버튼 높이) 이하
    const limitedY = Math.min(
      Math.max(0, dy) ,            // 0px보다 작아지지 않게
      imgH - buttonHeight - 65     // 이미지 높이 - 버튼 높이 - 여유 공간
    );

    // X축 (Left) 제한: 0 이상, (이미지 너비 - 버튼 너비) 이하
    const limitedX = Math.min(
      Math.max(0, dx),            // 0px보다 작아지지 않게
      imgW - buttonWidth - 5      // 이미지 너비 - 버튼 너비 - 여유 공간
    );

    return { top: limitedY, left: limitedX };
  };
const BUTTON_WIDTH = 60;  // padding, 폰트 크기 등을 고려한 추정 폭
  const BUTTON_HEIGHT = 28; // padding, 폰트 크기 등을 고려한 추정 높이
  


  const handleTabClick = (key) => {
    setActiveTab(key);
    console.log(`${key} 탭이 활성화되었습니다.`);
    // 여기에 탭 전환 시 필요한 로직 (데이터 로딩, 상태 변경 등)을 추가합니다.
  };
  async function processData() {

    const dailylookdata = await getdailylook()

          if(dailylookdata != '404 Not Found'){
          setUser(dailylookdata.user)

        const recommuser = await getRecommuser(dailylookdata.user.id)
        setRecommUsers(recommuser.results || []);
        setIslike(dailylookdata.is_like)
                  setDailylook(dailylookdata)
          }else{
            setIsFound(false)
          }

}

  const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };

  const handleItemClick = (url ,name) => {
        if (url) {
            window.open(url, '_blank');
        } else {
            const googleSearchBaseUrl = 'https://www.google.com/search?q=';
      
      // 2. 검색어(name)를 URL에 안전하게 인코딩
      // 한글이나 특수문자가 포함된 경우를 대비해 인코딩이 필수입니다.
      const encodedName = encodeURIComponent(name);
      
      // 3. 최종 검색 URL 생성
      const finalSearchUrl = googleSearchBaseUrl + encodedName;
      
      // 4. 새 탭에서 Google 검색 결과 페이지 열기
      window.open(finalSearchUrl, '_blank');
        }
    };

const handleNavigation = (tabKey) => {
    // ⭐️ 1. TABS의 key를 기반으로 경로를 설정합니다.
    const path = `/${tabKey}`;

    // 2. '/profile' 등의 특별 경로 처리 (이전 로직 유지)
    if (path === '/recommend' || path === '/favorite' || path === '/vote') {
        const savedToken = localStorage.getItem('user');
        const storedUserObject = JSON.parse(savedToken);
        
        // 토큰 체크 로직 강화 (null 또는 파싱 실패 대비)
        if (!storedUserObject || storedUserObject.username === 'temp') {
            navigate('/login');
        } else {
            // 실제 프로필 페이지로 이동 (예시: 사용자 ID와 함께)
            navigate(path);
        }
    } else {
        // 3. 일반적인 탭 경로 이동
        navigate(path);
    }
    console.log(`페이지 이동 요청: ${path}`);
};

// 탭 클릭 시 탭 UI 상태 업데이트도 처리하는 함수 추가
  const goToProfileDetail = (userId) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: userId.id,
    }).toString();
    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/profile?${queryParams}`);
  };

    useEffect(() => {

      
      processData()
  
    }, []);

        if (!dailylook && isFound) {
    return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
  }  


  return (
    // 메인 컨테이너: 상단 고정 및 양 끝 정렬

 <div>
          <ImagePopup 
                      isOpen={isPopupOpen} 
                      onClose={handleClosePopup} 
                  />

                  <LoginRequiredModal
                                                  isOpen={showLoginModal}
                                                  onClose={() => setShowLoginModal(false)}
                                                />
                  
                                                <ProfileRequiredModal
                                                  isOpen={showProfileModal}
                                                  onClose={() => setShowProfileModal(false)}
                                                />


    <header style={styles.header}>

      <div style={{display : 'flex', justifyContent:'space-between'}}>
      
      {/* 1. 왼쪽 탭 그룹 (Flex) */}
      <div style={styles.tabGroup}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          
          return (
            <div 
          key={tab.key} 
          // ⭐️ onClick 이벤트 핸들러 수정: tab.key를 인자로 전달
          onClick={() => handleNavigation(tab.key)} 
          style={styles.tabItem}
        >
              {/* 탭 텍스트 */}
              <span style={{ 
                ...styles.tabText,
                color: isActive ? styles.colors.activeText : styles.colors.inactiveText,
                fontWeight: isActive ? 'bold' : 'normal'
              }}>
                {tab.label}
              </span>
              
              {/* 활성 탭 밑줄 */}
              <div style={{
                ...styles.tabUnderline,
                // 활성 탭에만 검은색 선을 표시하고, 나머지는 투명하게 숨김
                backgroundColor: isActive ? styles.colors.activeUnderline : 'transparent'
              }} />
            </div>
          );
        })}
      </div>
      
      {/* 2. 오른쪽 아이콘 그룹 (Flex) */}
      <div style={styles.iconGroup}>
        {/* 연필 아이콘 */}
        {/* <FaPencilAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={{marginLeft: '15px', // 아이콘 간의 간격
        cursor: 'pointer', marginRight : '10pt'}}
        /> */}
        
        {/* 돋보기 아이콘 */}
        <MdOutlineCameraAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={styles.iconStyle}
        />
      </div>
      </div>
    </header>




{!isFound && !dailylook ? (
                <div style={styles.notFoundMessage}>
                    <span style={{
                        display: "block",
                        fontSize: '15pt',
                        marginTop: "0.83em",
                        marginBottom: "0.83em",
                        marginLeft: "0",
                        marginRight: "0",




                    }}
                    
                    
                    >평가 가능한 데일리룩이 없습니다.</span>
                    {/* <p>요청하신 데일리룩 정보를 찾을 수 없거나 삭제된 게시물입니다.</p> */}
                </div>
            ) : (<>
{!isLoading && (

      <section style={styles.infoSection}>
        

<div style={{ display: 'flex',alignItems: 'center',justifyContent:'space-between',width:'100%',margin:'0px 15px', marginTop:'100px', }}>
  <div style={{display: 'flex'}} onClick={() => goToProfileDetail(dailylook.user)}>
<CircularImageSquare 
         src= {dailylook.user.profile.image == null ? "https://www.studiopeople.kr/common/img/default_profile.png" : dailylook.user.profile.image}  
        alt="정사각형 이미지" 
        size={50} 
      />
       <div style={{ display: 'flex', flexDirection: 'column' }}>
        
        {/* 첫 번째 줄: 아이디 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
            <span style={{ 
                fontWeight: 'bold', 
                fontSize: '16px',
                color: '#000'
            }}>
                {dailylook.user.username}
            </span>
            {/* 사진 속 금색 뱃지 자리에 들어갈 요소 (선택 사항) */}
            <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                {/* 🥇 또는 이미지를 넣을 수 있습니다. */}
            </span>
        </div>

        {/* 두 번째 줄: 키와 체형 */}
        <div>
          <span style={{ 
            fontSize: '12px', 
            color: '#888' // 회색 텍스트
          }}>
            {dailylook.user.profile.height}
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#888',
            margin: '0 5px' // 구분자 간격
          }}>
            ·
          </span>
          <span style={{ 
            fontSize: '12px', 
            color: '#888'
          }}>
            {dailylook.user.profile.body_type}
          </span>
        </div>
        

        
                </div>
                </div>
                 <div style={{ display: 'flex', alignItems: 'center', marginLeft:'0' }}>
        
        {/* 팔로우 버튼 */}
        <button 
            style={{
                backgroundColor: userProfile.is_followed ? '#b7b7b7ff' :'#FF3640', // 사진 속 빨간색
                color: 'white',
                border: 'none',
                borderRadius: '8px', // 둥근 모서리
                padding: '8px 15px',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: '12px',
                width:'80px'
            }}
             onClick={() => {

              const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                                follow()
            }


          }
        }
        >
            {userProfile.is_followed ? "팔로잉" : "팔로우"}
        </button>
        
        {/* 상세 보기 메뉴 버튼 (점 세 개) */}
        {/* <button 
            style={{
                backgroundColor: 'transparent', // 배경 투명
                border: 'none',
                color: '#aaa', // 회색 점
                fontSize: '24px',
                cursor: 'pointer',
                marginLeft: '5px', // 팔로우 버튼과의 간격
                padding: '0 5px',
            }}
            onClick={() => setIsPopupOpen(true)}
        >
             
        </button> */}
      </div>
                
      </div>
        
        {/* 임시 박스 (원래 코드의 70px 박스) */}

      </section>
)}

    {isrecommview && recommUsers.length > 0 && (
                    <div style={styles.recommFollowContainer}>
                      <div style={styles.headerRow}>
                        <h3 style={styles.recommTitle}>팔로우 추천</h3>
                        <FaTimes size={20} color="#333" onClick={() => {setIsrecommview(false)}} />
                        </div>
                        <div style={styles.recommList}>
                            {recommUsers.slice(0, 4).map((user) => (
                                <FollowUserCard 
                                    key={user.id} 
                                    user={user} 
                                    onToggle={toggleRecommUserFollow} 
                                />
                            ))}
                        </div>
                       
                    </div>
                )}

        <div style={{margin: '10pt auto' }}>

            <div style={styles.sliderContainer}>
              <Slider {...bannerSettings}>

                <div>
                      <div style={{position: 'relative'}} ref={imageRef} onLoad={handleImageLoad}>
                          <img 
                            src={dailylook.image} 
                            onClick={toggleEquipments}
                            onLoad={handleImgLoad}
                            style={{      width: '100%',
      

                          display: isLoading ? 'none' : 'block'
                            }}
                          />
                          {showEquipments && imageSize.width > 0 && dailylook.equipments.map((item) => {
                                    
                                    // 3. 제한된 최종 위치 계산
                                    const { top, left } = getLimitedPosition(
                                      item.dy, 
                                      item.dx, 
                                      BUTTON_WIDTH, 
                                      BUTTON_HEIGHT
                                    );

                                    // 4. 버튼 스타일 적용
                                    return (
                                      <button 
                                        key={item.name}
                                        style={{
                                          ...styles.buttonBase, // 공통 스타일 분리 (아래 정의됨)
                                          position: 'absolute',
                                          top: `${top}px`,      // ⭐️ 제한된 top 위치 적용
                                          left: `${left}px`,    // ⭐️ 제한된 left 위치 적용
                                        }}
                                        onClick={() => console.log('테스트', item.name)}
                                      >
                                        {item.name}
                                      </button>
                                    );
                                  })}
                      </div>


                  </div>

                {dailylook.more_images.length > 1 && dailylook.more_images.slice(1).map((banner, index) => (
                  // 이미지 배너를 클릭 가능하게 <a> 태그로 감쌈
                  <div key={index}>
                      <a >
                          <img 
                            src={banner.image} 

                            style={styles.bannerImage} 
                          />
                      </a>
                  </div>
                ))}
              </Slider>
                            {!isLoading && (
              <div>

      <div style={styles.darkOverlay} />
      


      <div style={styles.starGroup}>
        {stars.map((index) => (
          <FaStar 
            key={index}
            size={40} // 별 크기
            color="#888" // 이미지 속 회색 별 색상
            style={styles.starIcon}
             onClick={() => setIsPopupOpen(true)}
          />
        ))}
      </div>




            </div>
                            )}
            </div>

      </div>

        {/* 6. 인기 데일리룩 문구 */}
        {!isLoading && (
      <div style={{padding:'0 3vw'}}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'space-between' }}>

       <div style={{ display: 'flex', flexDirection: 'column' }}>
        
        {/* 첫 번째 줄: 아이디 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
            <span style={{ 
                fontWeight: 'bold', 
                fontSize: '16px',
                color: '#000'
            }}>
                {dailylook.user.username}
            </span>
            {/* 사진 속 금색 뱃지 자리에 들어갈 요소 (선택 사항) */}
            {/* <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                {dailylook.created_at}
            </span> */}

             <TimeAgo isoString={dailylook.created_at} />
        </div>

 
        

        
                </div>
                 <div style={{ display: 'flex', alignItems: 'center' }}>
        
        {/* 팔로우 버튼 */}
        

        {/* 상세 보기 메뉴 버튼 (점 세 개) */}
        {/* <MdOutlineIosShare size="24"  onClick={() => setIsPopupOpen(true) } style={{
        marginLeft: '15px', // 아이콘 간의 간격
        cursor: 'pointer',
        marginRight:'20pt'
    }} /> */}

    <ShareButton linkToCopy= {MY_URL + '/dailylook?id=' + dailylook.id+"&category=d"} />

                        {islike?
                                      <FaHeart size="20"  
                                      
                                      onClick={() => 
                                        
                                        {
                                          const savedToken = localStorage.getItem('user');
                                          const storedUserObject = JSON.parse(savedToken);
                                          if(storedUserObject.username == 'temp'){
                                                      setShowLoginModal(true);
                        
                                          }else{
                                                                  like()
                                          }    
                                        }
                                      } style={{ 
                                        color : islike ?  '#ff0000ff' : '#000000ff'
                                      }} />
                                      :
                                      
                                      <FaRegHeart size="20"  
                                      
                                      onClick={() => 
                                        
                                        {
                                          const savedToken = localStorage.getItem('user');
                                          const storedUserObject = JSON.parse(savedToken);
                                          if(storedUserObject.username == 'temp'){
                                                      setShowLoginModal(true);
                        
                                          }else{
                                                                  like()
                                          }    
                                        }
                                      } style={{ 
                                        color : islike ?  '#ff0000ff' : '#000000ff'
                                      }} />
                                    }
      </div>




                
      </div>

                        {dailylook.introduction}

      <br/>
            <div style={styles.container}>
            {dailylook.equipments.map((item, index) => (
                <div 
                    key={index} 
                    style={styles.itemBox}
                    onClick={() => handleItemClick(item.url,item.name)}
                >
                    {/* 왼쪽 그룹: 파트 이름 + 브랜드/쇼핑몰 */}
                    <div style={styles.leftGroup}>
                        {/* 파트 이름 (예: SHOES, BOTTOM) */}
                        <span>{item.part}</span>
                        
                        {/* 타입 (브랜드/쇼핑몰) - 붉은색 텍스트 */}
                        <span style={styles.redText}>
                            {item.type}
                        </span>
                    </div>

                    {/* 오른쪽 이름 */}
                    <span style={styles.rightName}>
                        {item.name}
                    </span>
                </div>
            ))}
        </div>
{/* 
              <div style={styles.searchContainer}>
                <input
                  type="text"
                  placeholder="댓글을 입력하세요..."
                  value={searchTerm}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
                  style={styles.inputField}
                />
                
                <button onClick={handleSearch} style={styles.searchButton}>
                  <FaSearch size={20} color="#333" />
                </button>
              </div> */}

      </div>
        )}
        </>)}
</div>



  );
};

// ----------------------------------------------------
// 스타일 정의
// ----------------------------------------------------
function FollowUserCard({ user, onToggle }) {
    const isFollowed = user.is_followed;
    const thumbnail = user.profile?.thumbnail || "https://www.studiopeople.kr/common/img/default_profile.png";

    return (
        <div style={cardStyles.recommCard}>
            <img src={thumbnail} alt={user.username} style={cardStyles.recommImage} />
            <span style={cardStyles.recommUsername}>{user.username}</span>
            <button 
                onClick={() => onToggle(user)}
                style={isFollowed ? cardStyles.followingButton : cardStyles.followButton}
            >
                {isFollowed ? '팔로잉' : '팔로우'}
            </button>
        </div>
    );
}

const cardStyles = {
    // ... (기존 cardStyles 유지) ...
    
    // ⭐️ 추천 유저 카드 스타일
    recommCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        flexShrink: 0, // 카드가 줄어들지 않도록
        width: '80px', // 카드 너비 고정
    },
    recommImage: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: '5px',
    },
    recommUsername: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    },
    followButton: {
        backgroundColor: '#e74c3c', // 빨간색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
    followingButton: {
        backgroundColor: '#b7b7b7', // 회색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
};

const styles = {
  notFoundMessage: {
        textAlign: 'center',
        padding: '50px 20px',
        marginTop: '50px',
        color: '#666',
    },

  container: {
        position: 'relative',
        padding: '50px',
        textAlign: 'center',
    },
    button: {
        padding: '10px 20px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
    },
    toast: {
        position: 'fixed', // 화면에 고정
        bottom: '20px',    // 하단 20px 위치
        left: '50%',
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        backgroundColor: 'rgba(50, 50, 50, 0.9)',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        zIndex: 9999,
        opacity: 1,
        transition: 'opacity 0.3s ease-in-out',
    },

  headerRow: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝으로 분산 정렬 (제목/아이콘)
        alignItems: 'center', // 세로 중앙 정렬
        width: '100%',
        marginBottom: '10px', // 목록과의 간격
    },

  // ⭐️ 팔로우 추천 섹션 스타일
    recommFollowContainer: {
        padding: '0 1vw',
        
        position: 'relative', // X 버튼 등의 배치를 위해
    },
    recommTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        margin: '0 0 10px 0',
    },
    recommList: {
        display: 'flex',
        //overflowX: 'scroll', // ⭐️ 가로 스크롤 가능
        gap: '15px',
        paddingBottom: '10px',
        // 스크롤바 숨김 처리 필요 (App.css 또는 전역 스타일에서)
    },
    recommDivider: {
        height: '1px',
        backgroundColor: '#eee',
        margin: '15px 0',
    },
    dailylookTopInfo: {
        // 기존 데일리룩 상단 정보의 위치를 조정
        padding: '0 5vw',
    },
darkOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30%', // 이미지 높이의 약 30%를 검은색으로 덮음
        backgroundImage:'linear-gradient(0deg, black, transparent)',
        opacity: 0.9, // 약간의 투명도를 주어 자연스럽게 보이게 함
        zIndex: 1, // 별 아이콘보다 아래에 있어야 함
    },
    // 4. 별점 아이콘 그룹 스타일
    starGroup: {
        position: 'absolute',
        bottom: '10px', // 하단으로부터의 간격 조정
        left: '50%',
        transform: 'translateX(-50%)', // 중앙 정렬
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px', // 별 사이 간격
        width: '90%', // 별 그룹의 너비
        zIndex: 2, // 검은색 오버레이 위에 표시
    },
    starIcon: {
      width :'70',
      height :'70'
        // 추가 스타일이 필요하다면 여기에 정의
    },

    colors: {
        background: '#ffffff',
        border: '#d4d4d4ff',
        activeText: '#000000',
        inactiveText: '#a0a0a0', // 사진 속 회색 텍스트
        activeUnderline: '#000000',
        icon: '#000000'
    },
    header: {
        // 상단 고정 설정
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        
        // 레이아웃 설정
        display: 'flex',
        justifyContent: 'space-between', // 왼쪽 탭 그룹과 오른쪽 아이콘 그룹 분리
        alignItems: 'center',
        
        // 크기 및 외관
        height: '50px',
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${'#d4d4d4ff'}`, // 하단 구분선
        padding: '0 15px', // 좌우 패딩
        maxWidth: '420px', // 모바일 최대 너비
        margin: '0 auto', // 중앙 정렬
        zIndex: 10, // 다른 콘텐츠 위에 표시
    },
    tabGroup: {
        display: 'flex',
        alignItems: 'center',
        marginLeft:'15px'
        // 탭 사이의 공간을 줄여 사진과 유사하게 만듭니다.
    },
    tabItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 10px', // 탭 간의 가로 간격
        cursor: 'pointer',
        height: '100%',
        justifyContent: 'flex-end', // 밑줄을 바닥에 맞춥니다.
        // 탭 텍스트에만 상단 패딩을 줄 수도 있습니다.
    },
    tabText: {
        fontSize: '16px',
        paddingBottom: '8px', // 텍스트와 밑줄 사이의 간격
        whiteSpace: 'nowrap', // 텍스트 줄바꿈 방지
    },
    tabUnderline: {
        width: '100%',
        height: '2px', // 밑줄 두께
        // 활성 상태에 따라 색상이 결정됩니다.
    },
    iconGroup: {
        display: 'flex',
        alignItems: 'center',
        marginRight:'15px'
    },
    
buttonBase: {
        backgroundColor: '#000000ff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 15px',
        cursor: 'pointer',
        fontSize: '10px',
    },

  value: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0,
  },

container: {
        //width: '100%',
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        margin: '20px auto',
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#fafafa',
        borderRadius: '15px', // 둥근 모서리
        //boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },


  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        border: '1px solid #eee',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',

  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },

  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      position:'relative'
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      // height: '500px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '20px auto',
    border: '1px solid #ccc',
    borderRadius: '25px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  


}

export default Fashion_tab;